<div class="flex flex-col external-package-dialog p-26 h-100-percent">
  <div *ngIf="!dataLoading" class="flex flex-row justify-between items-center">
    <div *ngIf="!data?.dataLoaded" class="mat-headline-6 mb-0">{{data?.externalPackage?.name}}</div>
    <div *ngIf="data?.dataLoaded" class="mat-headline-6 mb-0">{{'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco }} - {{data?.instance?.name}}</div>
    <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" [matDialogClose]="false"></mat-icon>
  </div>
  <mat-divider *ngIf="!dataLoading" class="neutral-blue-6 mt-20 mb-20"></mat-divider>
  <div *ngIf="data?.dataLoaded" class="mat-headline-6 fs-18 pl-2">{{data?.externalPackage?.name}}</div>
  <div *ngIf="!dataLoading; else loader" class="flex flex-col endpoints update-build">
    <div *ngIf="data?.externalPackage?.references?.length > 0; else noDataFound" class="flex flex-col border-radius">
      <div class="component-header mat-body-2 fw-700 pl-50 flex items-center">{{'INSTANCE_DETAILS.UPDATE_BUILD.COMPONENT' | transloco | uppercase }}</div>
      <mat-accordion #accordion [togglePosition]="'before'" [multi]="false">
        <ng-container *ngFor="let component of data?.externalPackage?.references">
          <mat-expansion-panel (afterExpand)="onArrowClick(component)">
            <mat-expansion-panel-header class="component">
              <mat-panel-title>
                <span class="mat-body-1 fw-500">{{ component?.component | titlecase }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="flex flex-col w-100-percent gap-4">
              <div class="table-section package-sections p-16">
                <span class="mat-body-2 fw-600 flex mb-12">{{'INSTANCE_DETAILS.UPDATE_BUILD.IMAGES' | transloco}}</span>
                <ng-container *ngIf="dataSourceInner?.length > 0; else noInnerDataFound">
                  <div class="table-scroll">
                    <table mat-table [dataSource]="dataSourceInner" multiTemplateDataRows class="mat-elevation ext-package">
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name">{{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }}</th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 name">
                          <div class="overflow" title="{{data?.name | titlecase}}">{{data?.name | titlecase}}</div></td>
                      </ng-container>
                      <ng-container matColumnDef="path">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path">{{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }}</th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 path"><div class="overflow" title="{{data?.path | titlecase}}">{{data?.path ? (data?.path | titlecase) : '-'}}</div></td>
                      </ng-container>
                      <ng-container matColumnDef="currentVersion">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.TAG' | transloco | uppercase }} </th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'current-version': data?.version}">{{data?.version ? (data?.version | titlecase) : '-'}}</div></td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                    </table>
                  </div>
                </ng-container>
              </div>
              <div class="table-section package-sections p-16">
                <span class="mat-body-2 fw-600 flex mb-12">{{'INSTANCE_DETAILS.UPDATE_BUILD.PACKAGES' | transloco}}</span>
                <ng-container *ngIf="dataSourceInnerPackages?.length > 0; else noInnerDataFound">
                  <div class="table-scroll">
                    <table mat-table [dataSource]="dataSourceInnerPackages" multiTemplateDataRows class="mat-elevation ext-package">
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 name">
                          <div class="overflow" title="{{data?.name | titlecase}}">{{data?.name | titlecase}}</div></td>
                      </ng-container>
                      <ng-container matColumnDef="path">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 path"><div class="overflow" title="{{data?.path | titlecase}}">{{data?.path ? (data?.path | titlecase) : '-'}}</div></td>
                      </ng-container>
                      <ng-container matColumnDef="currentVersion">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.CURRENT_VERSION' | transloco | uppercase }} </th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'current-version': data?.version}">{{data?.version ? (data?.version | titlecase) : '-'}}</div></td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                    </table>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>
        </ng-container>
      </mat-accordion>
    </div>
    <ng-template #noDataFound>
      <div *ngIf="selectedExternalPackage" class="flex justify-center pt-8 pb-8 fw-400">
        {{'INSTANCE_DETAILS.UPDATE_BUILD.NO_COMPONENTS_AVALIABLE' | transloco }}
      </div>
    </ng-template>
    <ng-template #noInnerDataFound>
      <div>
        <table [dataSource]="dataSourceInnerLog" mat-table class="mat-elevation ext-package">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
          </ng-container>
          <ng-container matColumnDef="path">
            <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
          </ng-container>
          <ng-container matColumnDef="currentVersion">
            <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.CURRENT_VERSION' | transloco | uppercase }} </th>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
        </table>
        <div class="flex justify-center items-center fw-500 mb-20 mt-20 no-data">
          {{'INSTANCE_DETAILS.UPDATE_BUILD.NO_DATA_AVAILABLE' | transloco }}
        </div>
      </div>
    </ng-template>
  </div>
  <ng-template #loader>
    <div class="w-100-percent h-100-percent flex items-center justify-center">
      <mat-spinner class="" diameter="20" color="primary" mode="indeterminate"></mat-spinner>
    </div>
  </ng-template>
</div>